import { render, staticRenderFns } from "./sch_tjsheet.vue?vue&type=template&id=5a164a2a"
import script from "./sch_tjsheet.vue?vue&type=script&lang=js"
export * from "./sch_tjsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports